export enum KHeaderWidgetComponent {
  Logo = "Logo",
  CustomNavigation = "CustomNavigation",
  Basket = "Basket",
  User = "User",
  Home = "Home",
  SearchBar = "SearchBar",
  LangSelector = "LangSelector",
}

export enum KHeaderWidgetComponentContext {
  All = "All",
  TopBar = "TopBar",
  Burger = "Burger",
}
